var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpBTitleOverviewIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.26318,
    width: 6.73684,
    height: 6.73684,
    rx: 1,
    stroke: "#05073C",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05261 1L6.05261 1.8421C6.05261 2.48181 6.05261 2.80166 5.91167 3.0382C5.82659 3.18097 5.70727 3.30029 5.5645 3.38537C5.32796 3.52631 5.00811 3.52631 4.3684 3.52631V3.52631C3.7287 3.52632 3.40885 3.52632 3.17231 3.38537C3.02953 3.30029 2.91021 3.18097 2.82514 3.0382C2.68419 2.80166 2.68419 2.48181 2.68419 1.8421L2.68419 1",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10522 6.05273L5.63154 6.05273",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpBTitleOverviewIconBlack);
export default __webpack_public_path__ + "static/media/cp-b-title-overview-icon-black.f71f12ed0393a96807244b2bcd3e36ad.svg";
export { ForwardRef as ReactComponent };